import { render, staticRenderFns } from "./StudioMediaDetails.vue?vue&type=template&id=b49b5d6c&scoped=true&"
import script from "./StudioMediaDetails.vue?vue&type=script&lang=js&"
export * from "./StudioMediaDetails.vue?vue&type=script&lang=js&"
import style0 from "./StudioMediaDetails.vue?vue&type=style&index=0&id=b49b5d6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b49b5d6c",
  null
  
)

export default component.exports